import  types from "../actions/actionTypes";
import initialState from "./initialState";

export default function projectItemMilestonesReducer(state = initialState.projectItemMilestones, action) {

    const mergeInProjectItemMilestone = (projectItemMilestones, projectItemMilestoneUpdate) => {
        const projectItemMilestonesMinusStaleData = projectItemMilestones.filter(projectItemMilestone => projectItemMilestone.id !== projectItemMilestoneUpdate.id);       
        return projectItemMilestonesMinusStaleData.concat(projectItemMilestoneUpdate);
    }

     const deleteProjectItemMilestone = (current, id) => {
        return current.filter(projectItemMilestone => projectItemMilestone.id !== id);
    } 


    switch (action.type) {
        case types.LOAD_PROJECTITEMMILESTONE_SUCCESS:
        case types.UPDATED_PROJECTITEMMILESTONE_SUCCESS:
            return mergeInProjectItemMilestone(state, action.projectItemMilestone);
            case types.DELETED_PROJECTITEMMILESTONE:      
            return deleteProjectItemMilestone(state, action.projectItemMilestone.id);      
        case types.DELETED_PROJECTITEMMILESTONE_INCOMING:  
        case types.UPDATED_PROJECTITEMMILESTONE_INCOMING:
            return deleteProjectItemMilestone(state, action.payload.id);    
        default:
            return state;
    }
}